const pad = (n) => String(n).padStart(2, '0');

const TimerBar = ({ hours, minutes, seconds, timeLeftMs }) => {
  const isWarning  = timeLeftMs !== null && timeLeftMs < 5 * 60 * 1000;
  const isCritical = timeLeftMs !== null && timeLeftMs < 60 * 1000;

  return (
    <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl font-mono font-bold text-base transition-all duration-300 ${
      isCritical
        ? 'bg-red-500/20 text-red-400 border border-red-500/30 animate-pulse-slow'
        : isWarning
        ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30'
        : 'bg-white/10 text-white border border-white/20'
    }`}>
      <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{pad(hours)}:{pad(minutes)}:{pad(seconds)}</span>
    </div>
  );
};

export default TimerBar;
